export default __webpack_public_path__ + "static/media/color.d91a8ead.svg";